import { getLogger } from "@hoteltradergit/ht-telemetry-ui-lib";

/**
 * Telemetry helpers for the "empty roomtype × rateplan selection" guard.
 *
 * A blocked create/update/enable attempt is logged to Rapid7 via the telemetry
 * logger. Emptiness itself is checked at each call site because the payload
 * shapes differ (standard `allowedRateRoomCodes` vs derived
 * `rateRoomSelections[].combinations`). The user-facing message lives in
 * `src/constants/promoValidation.js` (EMPTY_COMBO_WARNING_MESSAGE).
 */

/** Log a blocked create/update/enable attempt (no combos selected). */
export function logEmptyComboBlocked({ action, promoId, propertyId }) {
  getLogger().warn("promoComboValidation", {
    type: "Validation",
    page_url: window.location.href,
    action, // "create" | "update" | "enable"
    promo_id: promoId ?? null,
    property_id: propertyId ?? null,
    error_desc: "Blocked: no roomtype/rateplan combination selected",
  });
}

/**
 * Log a failed silent pre-check fetch during enable. The check fails open
 * (activate still proceeds), so this is the only record that it did not run.
 */
export function logEmptyComboCheckFailed({
  action,
  promoId,
  propertyId,
  error,
}) {
  getLogger().error("promoComboValidation", {
    type: "Error",
    page_url: window.location.href,
    action,
    promo_id: promoId ?? null,
    property_id: propertyId ?? null,
    error_desc: "Combo pre-check fetch failed",
    error_stack: error?.stack ?? null,
  });
}
